﻿import type { IconProps } from './../../models/icon';

export function PinCodeIcon({
                            width = 24,
                            height = 24,
                            secondaryColor = 'rgb(var(--color-200) / 1)',
                            className = '',
                        }: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
            width={width}
            height={height}
            className={className}
        >
            <path
                fill={secondaryColor}
                d="M13.25 10.552c0 1.157-.3 1.92-.77 2.698H6.698l-.846-.846a2 2 0 0 1 .421-3.15L6.7 9.01V4.964a1.349 1.349 0 1 1 2.697 0V7.49c1.617.168 3.854.75 3.854 3.062Z"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12.48 13.25c.47-.778.77-1.542.77-2.698 0-2.312-2.237-2.894-3.854-3.062V4.964c0-.745-.604-1.349-1.348-1.349v0c-.745 0-1.35.604-1.35 1.35V9.01l-.424.242a2 2 0 0 0-.421 3.15l.846.847"
            />
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 1.25C.84 1.25.75 1.16.75 1S.84.75 1 .75M1.002 1.25c.16 0 .25-.09.25-.25s-.09-.25-.25-.25" />
            </g>
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 4.042c-.16 0-.25-.09-.25-.25s.09-.25.25-.25M1.002 4.042c.16 0 .25-.09.25-.25s-.09-.25-.25-.25" />
            </g>
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 6.834c-.16 0-.25-.09-.25-.25s.09-.25.25-.25M1.002 6.834c.16 0 .25-.09.25-.25s-.09-.25-.25-.25" />
            </g>
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4.231 6.834c-.16 0-.25-.09-.25-.25s.09-.25.25-.25M4.232 6.834c.16 0 .25-.09.25-.25s-.09-.25-.25-.25" />
            </g>
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4.231 4.042c-.16 0-.25-.09-.25-.25s.09-.25.25-.25M4.232 4.042c.16 0 .25-.09.25-.25s-.09-.25-.25-.25" />
            </g>
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4.231 1.25c-.16 0-.25-.09-.25-.25s.09-.25.25-.25M4.232 1.25c.16 0 .25-.09.25-.25s-.09-.25-.25-.25" />
            </g>
            <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7.473 1.25c-.16 0-.25-.09-.25-.25s.09-.25.25-.25M7.475 1.25c.16 0 .25-.09.25-.25s-.09-.25-.25-.25" />
            </g>
        </svg>
    );
}